<template>
    <div class="is-size-1">
        Oops something went wrong :-(
    </div>
</template>
